import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=33fe8532&scoped=true"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"
import style0 from "./product-card.vue?vue&type=style&index=0&id=33fe8532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe8532",
  null
  
)

export default component.exports